function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _ = require('lodash');

var React = require('react');

var ReactDOM = require('react-dom');

var listeners = {};
var initialized = false;

var onClickOutside = function onClickOutside(e) {
  _.forEach(listeners, function (listener) {
    if (!listener) {
      return;
    }

    var isClickInside = _.isElement(e.target) && listener.node.contains(e.target);

    if (!isClickInside) {
      listener.method(e);
    }
  });
};

var withClickOutside = function withClickOutside(Component) {
  var ClickOutside = /*#__PURE__*/function (_React$Component) {
    _inherits(ClickOutside, _React$Component);

    var _super = _createSuper(ClickOutside);

    function ClickOutside(props) {
      var _this;

      _classCallCheck(this, ClickOutside);

      _this = _super.call(this, props);
      _this.callbacks = [];

      _this.registerOnClickOutside = function (method, node) {
        var id = _.uniqueId();

        _this.callbacks.push(_.assign({
          method: method,
          id: id
        }, node ? {
          node: node
        } : {}));

        return id;
      };

      _this.clearOnClickOutside = function (id) {
        _this.callbacks = _.reject(_this.callbacks, {
          id: id
        });
        delete listeners[id];
      };

      _this.createListeners = function () {
        var rootNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));

        _.forEach(_this.callbacks, function (callback) {
          listeners[callback.id] = _.assign({
            node: rootNode
          }, callback);
        });
      };

      _this.initialize = function () {
        if (!initialized) {
          window.addEventListener('click', onClickOutside, true);
          initialized = true;
        }
      };

      return _this;
    }

    _createClass(ClickOutside, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.initialize();
        this.createListeners();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        _.forEach(this.callbacks, function (callback) {
          delete listeners[callback.id];
        });
      }
    }, {
      key: "render",
      value: function render() {
        var props = _.assign({}, this.props, {
          onClickOutside: this.registerOnClickOutside,
          clearOnClickOutside: this.clearOnClickOutside
        });

        return React.createElement(Component, props);
      }
    }]);

    return ClickOutside;
  }(React.Component);

  return ClickOutside;
};

module.exports = withClickOutside;